<template>
  <div class="group">
    <div class="label">
      {{ $l.popupQuizHint }}
    </div>

    <div
      v-for="(hint, i) in $store.state.quiz.hints"
      :key="i">
      ・{{ hint }}
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ]
}
</script>

<style lang="scss" scoped>
@import './_style.scss'
</style>
